import React, {Component} from 'react';

import {Link, withRouter} from 'react-router-dom';

import rectangle from './../assets/images/drag-and-drop-rectangle .svg';

import arrow from './../assets/images/arrow.svg';

import drag from './../assets/images/audiodraganddrop.svg';


class PuzzleInstructions extends Component {

    constructor() {
        super();

        this.state = {
            testDragAndDrop: true,
            triedAndfailedtoAdvance: false,
        };
    }

    render() {
        return (
            <section className="instructions">
                <header className="page-info">
                    <h1 className="page-title">Rehearsal</h1>
                    <h2 className="current-song-title">Current Song: <p> {this.props.songTitle}</p></h2>
                    <p className="narrative">The cast list was posted and you’re on it! Now it’s time to rehearse for
                        your big performance. Sure, you might be an aficionado of this musical, but show us how well you
                        really know this show-stopping number!</p>
                </header>
                <section className="content">
                    <article className="main-content">
                        <h2>Instructions</h2>
                        <p>	First, listen to the entire tap number by using the audio player near the top of the screen. Then, listen to each individual segment of the song. After listening to the segments, drag and drop  them into the correct order to match the song flow. Once all four segments are placed, click Check Answer to reveal your results. You must have all four segments placed before you can check your answer.
 </p>
                    </article>


                    {/* <aside className="drag-and-drop">
                        <h1 className={"try-it "+(!this.state.testDragAndDrop ? "animated bounce" : "")}>TRY IT</h1>
                        <div id="test-drop"
                             onDragOver={(e) => {
                                 e.preventDefault();
                             }}
                             onDrop={(e) => {
                                 e.preventDefault();
                                 this.setState({
                                     testDragAndDrop: true
                                 });
                                 e.target.appendChild(document.getElementById("test-drag"));
                                //  debugger;
                             }

                            }
                        />
                        <img src={arrow} className="drag-arrow-graphic" alt=""/>
                        <img src={drag} className={(this.state.triedAndfailedtoAdvance ? " wobble animated" : "")}
                             alt=""
                             draggable="true"
                             id="test-drag"
                             onAnimationEnd={() => {
                                this.setState({
                                    triedAndfailedtoAdvance: false,
                                });
                            }}
                        />

                        <p>click and drag</p>
                    </aside> */}
                </section>

                <footer className="page-footer">

                    <Link className='button-primary button-exit' to="/songs">Exit </Link>

                    <button
                        className={'button-primary ' + (this.state.testDragAndDrop ? "" : "button-primary-inactive")}
                        onClick={() => {
                            if (this.state.testDragAndDrop) {
                                this.props.history.push("/puzzle");
                            }

                            else{
                                this.setState({triedAndfailedtoAdvance : true})
                            }
                        }}
                    >Next
                    </button>
                </footer>
            </section>
        );
    }
}

export default withRouter(PuzzleInstructions);



// WEBPACK FOOTER //
// ./src/components/PuzzleInstructions.js